
import { useEffect, useRef } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import DessertsMenu from './components/DessertsMenu';
import PastriesMenu from './components/PastriesMenu';
import Services from './components/Services';
import Contact from './components/Contact';

export default function Home() {
  const sectionsRef = useRef<(HTMLElement | null)[]>([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.3,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    sectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-gradient-to-b from-[#FDF8F3] via-[#F5EDE4] to-[#EDE4D8]">
      <Hero />
      <About ref={(el) => (sectionsRef.current[0] = el)} />
      <DessertsMenu ref={(el) => (sectionsRef.current[1] = el)} />
      <PastriesMenu ref={(el) => (sectionsRef.current[2] = el)} />
      <Services ref={(el) => (sectionsRef.current[3] = el)} />
      <Contact ref={(el) => { sectionsRef.current[4] = el; }} />
    </div>
  );
}
